module Home

open Fable.React
open Fable.React.Props
open Fulma
open App.Types

let pageSection header content =
    Container.container [] [ 
        Heading.h1 [] [ str header ]
        content
        br []
        br []
    ]

let pageLink (page : Global.ExternalPageInfo) =
  a [ Href (Global.toHash (Global.Page.Plugin (page.code))) ] [ str (page.code) ]


let view model =
  Container.container
    []
    [
      pageSection "Welcome"
        (p [] [ str "This is a central portal for managing all IRT and Dotyk devices and applications"])
  
      pageSection "Applications"
        (p [] [ str "Go to "; a [ Href "#apps" ] [ str "Applications" ]; str " page to edit application settings and accesses" ])
  
      match model.PluginPages with
      | None -> nothing
      | Some pages ->
        match pages.pages |> List.tryFind (fun i -> i.code = "Dotyk.Store") with
        | None -> nothing
        | Some page ->
          pageSection "Dotyk.Store"
            (p [] [ str "Go to "; pageLink page; str " page to manage application packages" ])
  
        match pages.pages |> List.tryFind (fun i -> i.code = "IAM") with
        | None -> nothing
        | Some page ->
          pageSection "IAM"
            (p [] [ str "Go to "; pageLink page; str " page to manage IAM subscriptions and other settings" ])
    ]
